import React, { Suspense, lazy, useEffect } from 'react';
import AppLayout from 'layout/app-layout';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { clearUser } from 'redux/slices/auth';
import AppRoutes from 'routers';
// ===== lazy imports =====
const Login = lazy(() => import('pages/auth'));
const CreateDepartament = lazy(() => import('pages/createDepartament'));
const Department = lazy(() => import('pages/departament'));
const Monitoring = lazy(() => import('pages/monitoring'));
const User = lazy(() => import('pages/users'));
const Car = lazy(() => import('pages/car'));
const Sensor = lazy(() => import('pages/sensor'));
const Server = lazy(() => import('pages/server'));
const Access = lazy(() => import('pages/access'));
const NotFound = lazy(() => import('components/404'));


// Loader (xohlasang spinner qo‘yasan)
const Loader = () => <div style={{ padding: 24 }}>Loading...</div>;

export default function App() {
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const dispatch = useDispatch();
  // Token tekshiruvi - agar token yo'q bo'lsa user'ni o'chirish
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token && user) {
      // Token yo'q lekin user Redux store'da bor bo'lsa, user'ni o'chirish
      dispatch(clearUser());
    }
  }, [user, dispatch]);

  const auth = (children) =>
    user ? <Navigate to='/create' replace /> : children;
  const checkDep = (children) =>
    user?.department ? <Navigate to='/' replace /> : children;
  const login = (children) =>
    !user ? <Navigate to='/login' replace /> : children;

  const path = () => {
    const hasDepartment = user?.permission?.some(
      (item) => 'Департамент' in item
    );
    if (hasDepartment) return <Department />;

    switch (user?.url) {
      case 'Мониторинг':
        return <Monitoring />;
      case 'Транспорт':
        return <Car />;
      case 'Сервер':
        return <Server />;
      case 'Танки':
        return <Sensor />;
      case 'Доступ':
        return <Access />;
      case 'Пользователь':
        return <User />;
      default:
        return <Department />;
    }
  };

  return (
    <HashRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path='/login' element={auth(<Login />)} />
          <Route path='/create' element={checkDep(<CreateDepartament />)} />

          <Route path='/' element={login(<AppLayout />)}>
            <Route index element={path()} />
            {AppRoutes.map(({ path, component: Component }) => (
              <Route key={path} path={path} element={<Component />} />
            ))}
          </Route>

          <Route path='*' element={<NotFound />} />
        </Routes>
      </Suspense>

      <ToastContainer
        position='top-right'
        autoClose={4000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        closeButton={false}
      />
      <SpeedInsights />
    </HashRouter>
  );
}
